import { FC } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { selectIsMixedListing } from 'shared/selectors/jsonQuery';
import { FlatOldConstructionYearContainer, NewbuildingConstructionYearContainer } from './containers';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { InlineFilterSection } from 'shared/components/InlineFilterSection';

export const ConstructionYearContainer: FC = () => {
  const isMixed = useSelector(selectIsMixedListing);

  return (
    <AdvancedFilterRow label="Год постройки">
      {isMixed && (
        <>
          <InlineFilterGroup>
            <InlineFilterSection title="На вторичке" dataTestId="flatOldConstructionYear">
              <FlatOldConstructionYearContainer />
            </InlineFilterSection>
          </InlineFilterGroup>

          <InlineFilterGroup>
            <InlineFilterSection title="В новостройках" dataTestId="newbuildingConstructionYear">
              <NewbuildingConstructionYearContainer />
            </InlineFilterSection>
          </InlineFilterGroup>
        </>
      )}

      {!isMixed && <FlatOldConstructionYearContainer />}
    </AdvancedFilterRow>
  );
};
